/**
 * Register custom error constructors to get them after de-serialization on client.
 */
import { addKnownErrorConstructor, deserializeError } from 'serialize-error';
import { FetchError } from './fetchError';
import { SupplierApiError } from './suppliers/error';
import { ProcurementApiError } from './procurement/error';

export const buyeasyDeserializeError = deserializeError;

export function registerCustomErrors() {
  addKnownErrorConstructor(FetchError);
  addKnownErrorConstructor(SupplierApiError);
  addKnownErrorConstructor(ProcurementApiError);
}
